export const SHOW_MODAL = 'modal/SHOW';
export const showModal = (type, props, meta = {}) => ({
  type: SHOW_MODAL,
  payload: { type, props },
  meta,
});
